import { orderBy } from 'lodash'

type returnValue = {
  value: MData.User['_id']
  label: string
}

export const getUserOptions = (
  users: Pick<MData.User, '_id' | 'fullName' | 'employeeNumber' | 'archived'>[],
  { showArchived }: { showArchived: boolean } = { showArchived: false }
): returnValue[] => {
  const sortedUsers = orderBy(users, ['fullName'])

  return sortedUsers
    .filter(({ archived }) => {
      return showArchived || !archived
    })
    .map(({ _id, fullName, employeeNumber = '' }) => ({ value: _id, label: `${fullName} (${employeeNumber})`, fullName }))
}
